module.exports = __webpack_public_path__ + "static/media/test-drive.aed60234.jpg";